import { render, staticRenderFns } from "./AddAfterSaleRefundOrder.vue?vue&type=template&id=42620857&scoped=true"
import script from "./AddAfterSaleRefundOrder.vue?vue&type=script&lang=js"
export * from "./AddAfterSaleRefundOrder.vue?vue&type=script&lang=js"
import style0 from "./AddAfterSaleRefundOrder.vue?vue&type=style&index=0&id=42620857&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42620857",
  null
  
)

export default component.exports